<template>
  <div>
    <div  v-for="serviceOption in SERVICE.serviceOptions" :key="serviceOption.id">
      <div v-if="serviceOption.description == 'Kostenpflichtige Optionen'">
        <b-form-checkbox-group
            v-model="CHECKOUT_DATA.additionalOptions"
            stacked
        >
          <div v-for="(serviceOptionItem, key) in serviceOption.children" :key="serviceOptionItem.id">
            <div v-if="serviceOptionItem.children" :class="key > 0 ? 'mt-2' : ''">
              <template v-if="serviceOptionItem.description != 'TV'">
                <h2 class="text-primary font-medium-1">{{ serviceOptionItem.description }}</h2>
                <div v-for="serviceItem in serviceOptionItem.children" :key="serviceItem.id">
                  <b-form-checkbox :value="serviceItem"
                                   v-if="serviceItem.description.indexOf('Fritzbox') == -1 &&
                  serviceItem.description.indexOf('Lieferpauschale') == -1 &&
                  serviceItem.description.indexOf('Arris') == -1"
                  >
                    {{ serviceItem.description }} - {{ formatPrice(serviceItem.price) }}
                    {{ serviceItem.item.baseQuantity == 1 ? 'einmalig' : 'monatlich' }}


                    <b-avatar
                        v-if="serviceOptionItem.descriptionDetailed"
                        class="mr-1 question-mark"
                        variant="secondary"
                        size="sm"
                        v-b-tooltip.hover.top="serviceItem.descriptionDetailed"
                        text="?"
                    >
                    </b-avatar>
                  </b-form-checkbox>
                </div>
              </template>
            </div>
            <div v-else>
              <b-form-checkbox :value="serviceOptionItem"
                               v-if="
                               serviceOptionItem.description.toLowerCase().indexOf('fritzbox') == -1 &&
                               serviceOptionItem.description.toLowerCase().indexOf('lieferpauschale') == -1 &&
                               serviceOptionItem.description.toLowerCase().indexOf('arris') == -1 &&
                               serviceOptionItem.description.toLowerCase().indexOf('versandkosten') == -1
                               "
                               @input="updateSprachkanalSelect()"
              >
                <service-option-item-text
                    :service-option-item="serviceOptionItem"
                    :product-dependencies="SERVICE.serviceOptionsDependencies"
                    :foot-node="serviceOptionItem.description == 'Erhöhung „Upload-Geschwindigkeit“' ? '2' : ''"
                    :extra-description-text="serviceOptionItem.description == 'Zusätzlicher Sprachkanal' ? ' je Sprachkanel' : ''"
                />

                <div v-if="serviceOptionItem.description == 'Zusätzlicher Sprachkanal' && showSprachkanel">
                  <div class="p-1 bg-light mb-1 mt-1">
                    <p data-v-7ca792d6="" class="font-weight-bolder mb-0">Wichtiger Hinweis:</p>
                    <p>In diesem Tarif ist ein Sprachkanal mit 2 Rufnummern inklusive.<br/>
                      Bitte wählen Sie die Anzahl an zusätzlichen Sprachkanälen aus. Je Sprachkanal erhalten Sie 2 weitere Rufnummern.</p>
                    Die Aktivierungsgebühr fällt nur einmalig an, unabhängig von der Anzahl der Sprachkanäle.
                  </div>

                  <b-form-group
                      label="Anzahl zusätzlicher Sprachkanäle"
                      label-for="phoneline-takeover-numbers-count"
                      class="mt-1"
                  >
                    <b-form-select
                        id="phoneline-takeover-numbers-count"
                        :options="getSprachkanalOptions()"
                        value="1"
                        v-model="CHECKOUT_DATA.countVoiceChannels"
                        value-field="value"
                        text-field="text"
                    >
                    </b-form-select>
                  </b-form-group>
                </div>

                <b-avatar
                    v-if="serviceOptionItem.descriptionDetailed"
                    class="mr-1 question-mark"
                    variant="secondary"
                    size="sm"
                    v-b-tooltip.hover.top="serviceOptionItem.descriptionDetailed"
                    text="?"
                >
                </b-avatar>
              </b-form-checkbox>
            </div>
          </div>
        </b-form-checkbox-group>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {
  BFormCheckboxGroup,
  BFormCheckbox, BFormSelect
} from "bootstrap-vue";
import ServiceOptionItemText from "@/components/ServiceOptionItemText";

export default {
  name: "HardwareSection",
  components: {
    BFormCheckboxGroup,
    BFormCheckbox,
    BFormSelect,
    ServiceOptionItemText
  },
  data() {
    return {
      selected: [],
      address: {},
      value: [],
      showInfoBlock: process.env.VUE_APP_ROOT_SHOW_CABLE_4_INFO_BLOCKS,
      showSprachkanel: false,
    }
  },
  computed: {
    ...mapGetters(['SERVICE', 'CHECKOUT_DATA']),
  },
  methods: {
    formatPrice(price) {
      return new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(price / 100)
    },
    updateSprachkanalSelect() {
      this.showSprachkanel = false
      this.CHECKOUT_DATA.additionalOptions.forEach(item => {
        if (item.description === 'Zusätzlicher Sprachkanal') {
          this.showSprachkanel = true
        }
      })
    },
    getSprachkanalOptions() {
      let data = []

      for (let i = 1; i <= 5; i++) {
        data.push({
          value: i,
          text: i + (i == 1 ? ' zusätzlicher Sprachkanal' : ' zusätzliche Sprachkanäle') +  ' mit ' + i*2 + ' zusätzlichen Rufnummern'
        })
      }

      return data
    },
  },
  mounted() {
    this.updateSprachkanalSelect()
  }
}
</script>

<style scoped>
.custom-control-label .question-mark {
  background: #000;
  width: 1rem;
  height: 1rem;
  position: relative;
  top: -2px;
}

.tooltip-inner {
  white-space: pre-line;
  text-align: left;
  max-width: 240px;
}
</style>
